import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { patchCircuitActive } from '../../../../actions';

const CircuitActiveButton = ({
  dispatchActiveCircuit,
  circuitId,
  active,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickActive = () => dispatchActiveCircuit({ circuitId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickActive}
        onClickCancel={closeModal}
      />
      <Button color={active ? 'danger': 'success'} onClick={openModal} disabled={disabled}>
        <i className={active ? "fa fa-ban" : "fa fa-check-circle-o"}/>{active ? ' Desactivar' : ' Activar'} 
      </Button>
    </>
  );
};

CircuitActiveButton.propTypes = {
  dispatchActiveCircuit: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  active: PropTypes.bool.isRequired,
  circuitId: PropTypes.number.isRequired,
};

CircuitActiveButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchActiveCircuit: patchCircuitActive,
};

export default connect(null, mapDispatchToProps)(CircuitActiveButton);
